import { simplePath } from "../../utils.js";
import { baseSchema, emailValidation } from "./validation.js";
const GET_PROFILE_SETTINGS = 'v2/user-profile-settings';
function get_profile_settings_path() {
    return simplePath(GET_PROFILE_SETTINGS, {});
}
const schema = baseSchema.required();
const formSchema = baseSchema.append({
    email: emailValidation
}).required();
export { GET_PROFILE_SETTINGS, formSchema, get_profile_settings_path, schema };
